import script from "./Tower.vue?vue&type=script&setup=true&lang=ts"
export * from "./Tower.vue?vue&type=script&setup=true&lang=ts"

import "./Tower.vue?vue&type=style&index=0&id=5e1fa59e&lang=scss"

const __exports__ = script;

export default __exports__